import StructureAPI from "../../../../../store/reducers/builderReducers/structure/structureApi";
import { useAppSelector } from "../../../../../store/hooks";
import { AllComponents } from "../../../../_default/interfaces/base";
import { useCallback, useEffect, useState } from "react";
import React from "react";
import {
  addNewComponent,
  deleteComponentById,
} from "../../../../../store/reducers/builderReducers/structure/structureActions";
import { editorId } from "../../../../../pages/Builder";
import {
  getBuilderComponentRootElement,
  getComponentDomId,
  editorIdsFromComponent,
} from "../../../../../store/reducers/builderReducers/editor/editorSelectionHelpers";
import { setEditableComponentId } from "../../../../../store/reducers/textEditor/textEditorActions";
import { updateEditor } from "../../../../../store/reducers/builderReducers/editor/editorActions";
import { MoreHorizOutlined } from "@mui/icons-material";
import {
  getComponentFromStructureMap,
  getComponentIdentityKey,
} from "../../../../_default/utilities/componentIdentity";
import { DEFAULT_NEW_COLUMN_CLASSES } from "../../../../../utils/Helpers";
import {
  EDITOR_ADD_ELEMENT_MORE_OVERFLOW_ID,
  broadcastExclusiveOverflowMenuActive,
  getExclusiveOverflowMenuActiveId,
  subscribeExclusiveOverflowMenuActive,
} from "../../useBuilderExclusiveOverflowMenu";
interface Props {
  component: AllComponents;
}

export default function SelectElementType({ component }: Props) {
  const typographies = useAppSelector((state) => state.builder.typographies);
  const website = useAppSelector((state) => state.builder.website);
  const structureComponents = useAppSelector(
    (state) => state.builder.structure.components
  );
  const builderEditor = useAppSelector((state) => state.builder.editor);
  const [style, setStyle] = useState<React.CSSProperties>();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    return subscribeExclusiveOverflowMenuActive((activeId) => {
      if (activeId == null) return;
      if (activeId === EDITOR_ADD_ELEMENT_MORE_OVERFLOW_ID) return;
      setExpanded(false);
    });
  }, []);

  const toggleExpanded = useCallback(() => {
    setExpanded((was) => {
      if (was) {
        if (
          getExclusiveOverflowMenuActiveId() ===
          EDITOR_ADD_ELEMENT_MORE_OVERFLOW_ID
        ) {
          broadcastExclusiveOverflowMenuActive(null);
        }
        return false;
      }
      broadcastExclusiveOverflowMenuActive(EDITOR_ADD_ELEMENT_MORE_OVERFLOW_ID);
      return true;
    });
  }, []);

  useEffect(() => {
    return () => {
      if (
        getExclusiveOverflowMenuActiveId() ===
        EDITOR_ADD_ELEMENT_MORE_OVERFLOW_ID
      ) {
        broadcastExclusiveOverflowMenuActive(null);
      }
    };
  }, []);

  const defaultTypography = useAppSelector(
    (state) => state.builder.website.defaultTypographyId
  );

  const parentElement = useAppSelector((state) =>
    getComponentFromStructureMap(
      state.builder.structure.components,
      (component as any).parent_uuid ?? component.parent_id
    )
  );

  let elementTypes = [
    { label: "Text", value: "text" },
    { label: "Products", value: "ProductsComponent" },
    { label: "Events by Group", value: "eventComponent" },
    { label: "Event Round Trip", value: "eventRoundTripComponent" },
    { label: "Event Additional Items", value: "eventAdditionalItemsComponent" },
    { label: "Product", value: "ProductDetailComponent" },
    { label: "Checkout", value: "Checkout" },
    { label: "Button", value: "Button" },
    { label: "Contact Form", value: "form" },
    { label: "Inner Section", value: "inner_section" },
    { label: "Image / Video", value: "image" },
    // { label: "Menu Item", value: "NavItemComponent" },
    { label: "Media Slider", value: "MediaSlider" },
    { label: "Accordion", value: "Accordion" },
    { label: "Single Product", value: "singleProduct" },
    { label: "Product Slider", value: "ProductSlider" },
    { label: "Navigation Container", value: "navigation-container" },
    { label: "iFrame", value: "iframe" },
    { label: "Cart", value: "CartComponent" },
    { label: "Icon", value: "IconComponent" },
    { label: "Language select", value: "LanguageSelect" },
    { label: "Nav Item", value: "nav-item" },
    // { label: "Content", value: "ContentComponent" },
    //{ label: "Section", value: "section" },

    //{ label: "ProductsService", value: "ProductsServicesComponent" },
    // 'Link',
    // 'NavItemComponent',
  ].sort((a, b) => a.label.localeCompare(b.label));

  if (parentElement && parentElement.type === "inner_section") {
    // Remove inner_section from elementTypes

    elementTypes.filter((x) => x.value !== "inner_section");

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "inner_section"),
      1
    );
  }

  if (component.type === "nav-item") {
    elementTypes = elementTypes.filter((x) => x.value !== "nav-item");
  }

  if (component.type === "navigation-container") {
    // Only nav-item may be added inside a navigation container (matches DnD / structure rules).
    elementTypes = elementTypes.filter((x) => x.value === "nav-item");
  }

  if (component.type === "nav") {
    // Remove everything from elementTypes except nav-item
    // elementTypes.filter((x) => x.value !== "nav-item");
  }

  if (component.type === "header") {
    elementTypes.filter((x) => x.value !== "inner_section");

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "form"),
      1
    );

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "inner_section"),
      1
    );

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "ProductDetailComponent"),
      1
    );

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "ProductsComponent"),
      1
    );

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "ProductsServicesComponent"),
      1
    );

    elementTypes.splice(
      elementTypes.findIndex((x) => x.value === "Checkout"),
      1
    );
  }

  const quickTypes = elementTypes.filter((x) =>
    ["text", "Button", "image"].includes(x.value)
  );

  const observer = new ResizeObserver((entries) => {
    setStyle({ maxWidth: `${entries[0].target.clientWidth}px` });
  });
  useEffect(() => {
    const el = getBuilderComponentRootElement(component);
    if (el) {
      observer.observe(el);
    }
    return () => {
      observer.disconnect();
    };
  }, [component]);

  function syncSelectionWithCreatedComponent(created: AllComponents) {
    const targetId = getComponentIdentityKey(created);
    setEditableComponentId(targetId);
    updateEditor({
      ...builderEditor,
      hasEdited: builderEditor.hasEdited,
      ...editorIdsFromComponent(created, structureComponents),
    } as any);
  }

  function onTypeClick(type: string) {
    const containerTypes = new Set([
      "section",
      "inner_section",
      "footer",
      "Accordion",
      "nav",
      "navigation-container",
      "header",
    ]);
    const isContainerAnchor = containerTypes.has(component.type);
    const insertionParent = isContainerAnchor ? component : parentElement;
    const parentId = insertionParent?.uuid?.trim() || insertionParent?.id;
    const selectedComponentKey = getComponentIdentityKey(component);
    const selectedIndexInParent = !isContainerAnchor
      ? (insertionParent?.childWebpageComponentRelations ?? []).findIndex(
          (relation) => {
            const relationChildRef =
              relation.child_uuid?.trim() || relation.child_id;
            const relationChildComponent = getComponentFromStructureMap(
              structureComponents,
              relationChildRef
            );
            return (
              relationChildComponent != null &&
              getComponentIdentityKey(relationChildComponent) ===
                selectedComponentKey
            );
          }
        )
      : -1;
    const nextSortOrder = !isContainerAnchor
      ? selectedIndexInParent >= 0
        ? selectedIndexInParent + 2
        : Number(component.sort_order ?? 0) + 1
      : component.childWebpageComponentRelations.length > 0
      ? component.childWebpageComponentRelations.length + 1
      : 1;
    let textAttributes: any[] = [];

    const sortValue = nextSortOrder;

    // TODO: Need to check if inner section can be added to an elemenet

    // if (type === "image") {
    //   StructureAPI.addComponent(component.webpage_id, {
    //     type: type,

    //     attributes: [
    //       { name: "src", value: "", type: "attributes" },
    //       { name: "alt", value: "", type: "attributes" },
    //       { name: "styles", value: "", type: "attributes" },
    //     ],
    //     parent_id: parentId,
    //   });

    //   return;
    // }

    if (type === "CartComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "cart",
        attributes: [],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "iframe") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "iframe",
        attributes: [],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "eventComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "eventComponent",
        attributes: [],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "eventRoundTripComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "eventRoundTripComponent",
        attributes: [],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "eventAdditionalItemsComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "eventAdditionalItemsComponent",
        attributes: [],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "navigation-container") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "navigation-container",
        attributes: [
          { name: "paddingLeft", value: "10px", type: "styles" },
          { name: "paddingRight", value: "10px", type: "styles" },
          { name: "paddingTop", value: "10px", type: "styles" },
          { name: "paddingBottom", value: "10px", type: "styles" },
        ],
        parent_id: parentId,
        sort_order: nextSortOrder,
      }).then((x) => {
        StructureAPI.addComponent(component.webpage_id, {
          type: "nav-item",
          sort_order: nextSortOrder,
          attributes: [
            {
              type: "attributes",
              name: "text",
              value: "Nav link",
            },
            {
              type: "attributes",
              name: "link",
              value: { url: "", type: "None", target: "" },
            },
            {
              type: "attributes",
              name: "typography_id",
              value: typographies.find((x) => x.id === defaultTypography)?.id
                ? typographies.find((x) => x.id === defaultTypography)?.id
                : typographies.find((x: any) => x.tag == "p")?.id ?? null,
            },
          ],
          parent_id: x.payload[Object.keys(x.payload)[0]].id,
        });
      });

      return;
    }

    if (type === "LanguageSelect") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "language-select",
        attributes: [
          {
            type: "attributes",
            name: "dropdown",
            value: "none",
          },
          {
            type: "attributes",
            name: "type",
            value: "image",
          },
          {
            type: "attributes",
            name: "size",
            value: "16px",
          },
        ],
        parent_id: parentId,
        sort_order: nextSortOrder,
      });

      return;
    }

    if (type === "singleProduct") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "SingleProductComponent",
        sort_order: nextSortOrder,
        attributes: [],
        parent_id: parentId,
      });

      return;
    }

    if (type === "ProductSlider") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "product-slider",
        sort_order: nextSortOrder,
        attributes: [],
        parent_id: parentId,
      });

      return;
    }

    if (type === "nav-item") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "nav-item",
        sort_order: nextSortOrder,
        attributes: [
          {
            type: "attributes",
            name: "text",
            value: "Nav link",
          },
          {
            type: "attributes",
            name: "link",
            value: { url: "", type: "None", target: "" },
          },
          {
            type: "attributes",
            name: "typography_id",
            value: typographies.find((x) => x.id === defaultTypography)?.id
              ? typographies.find((x) => x.id === defaultTypography)?.id
              : typographies.find((x: any) => x.tag == "p")?.id ?? null,
          },
        ],
        parent_id: parentId,
      });

      return;
    }

    if (type === "Accordion") {
      StructureAPI.addComponent(component.webpage_id, {
        type: type,
        sort_order: sortValue,
        attributes: [
          {
            type: "styles",
            name: "backgroundColor",
            value: "#fafafa",
          },
          {
            type: "styles",
            name: "borderTopWidth",
            value: "1px",
          },
          {
            type: "styles",
            name: "borderBottomWidth",
            value: "1px",
          },
          {
            type: "styles",
            name: "borderLeftWidth",
            value: "1px",
          },
          {
            type: "styles",
            name: "borderRightWidth",
            value: "1px",
          },
          {
            type: "styles",
            name: "borderTopStyle",
            value: "solid",
          },
          {
            type: "styles",
            name: "borderBottomStyle",
            value: "solid",
          },
          {
            type: "styles",
            name: "borderLeftStyle",
            value: "solid",
          },
          { name: "paddingLeft", value: "20px", type: "styles" },
          { name: "paddingRight", value: "20px", type: "styles" },
          { name: "paddingTop", value: "20px", type: "styles" },
          { name: "paddingBottom", value: "20px", type: "styles" },

          {
            type: "styles",
            name: "borderRightStyle",
            value: "solid",
          },
          {
            type: "styles",
            name: "borderTopColor",
            value: "#ededed",
          },
          {
            type: "styles",
            name: "borderBottomColor",
            value: "#ededed",
          },
          {
            type: "styles",
            name: "borderLeftColor",
            value: "#ededed",
          },
          {
            type: "styles",
            name: "borderRightColor",
            value: "#ededed",
          },
        ],
        parent_id: parentId,
      }).then((x: any) => {
        const created = x.payload[Object.keys(x.payload)[0]];
        StructureAPI.addComponent(component.webpage_id, {
          type: "section",
          sort_order: 1,
          attributes: [
            {
              name: "classes",
              value: DEFAULT_NEW_COLUMN_CLASSES,
              type: "attributes",
            },
            { name: "paddingLeft", value: "0px", type: "styles" },
            { name: "paddingRight", value: "0px", type: "styles" },
            { name: "paddingTop", value: "0px", type: "styles" },
            { name: "paddingBottom", value: "0px", type: "styles" },
            { name: "marginTop", value: "0px", type: "styles" },
            { name: "marginBottom", value: "0px", type: "styles" },
            { name: "marginRight", value: "20px", type: "styles" },
          ],
          parent_id: x.payload[Object.keys(x.payload)[0]].id,
        }).then((x: any) => {
          StructureAPI.addComponent(component.webpage_id, {
            type: "text",
            sort_order: 1,
            attributes: [
              {
                name: "text",
                value: "<span style='fontSize: 24px'>Accordion item</span>",
                type: "attributes",
              },
              {
                type: "attributes",
                name: "typography_id",
                value: typographies.find((x) => x.id === defaultTypography)?.id
                  ? typographies.find((x) => x.id === defaultTypography)?.id
                  : typographies.find((x: any) => x.tag == "p")?.id ?? null,
              },
              { name: "paddingBottom", value: "0px", type: "styles" },
              { name: "paddingTop", value: "0px", type: "styles" },
              { name: "marginTop", value: "0px", type: "styles" },
              { name: "marginBottom", value: "0px", type: "styles" },
            ],
            parent_id: x.payload[Object.keys(x.payload)[0]].id,
          });
        });
      });

      return;
    }

    if (type === "inner_section") {
      StructureAPI.addComponent(component.webpage_id, {
        type: type,
        sort_order: sortValue,
        attributes: [
          { name: "classes", value: "inner-section", type: "attributes" },
          { name: "paddingTop", value: "20px", type: "styles" },
          { name: "paddingLeft", value: "0px", type: "styles" },
          { name: "paddingBottom", value: "20px", type: "styles" },
          { name: "paddingRight", value: "0px", type: "styles" },
          {
            name: "content_width_unit",
            value: website?.contentWidthUnit,
            type: "attributes",
          },
          {
            name: "content_width_size",
            value: website?.contentWidthSize,
            type: "attributes",
          },
        ],
        parent_id: parentId,
      }).then((x: any) => {
        const created = x.payload[Object.keys(x.payload)[0]];
        StructureAPI.addComponent(component.webpage_id, {
          type: "section",
          sort_order: 1,
          attributes: [
            {
              name: "classes",
              value: DEFAULT_NEW_COLUMN_CLASSES,
              type: "attributes",
            },
            { name: "paddingTop", value: "20px", type: "styles" },
            { name: "paddingLeft", value: "20px", type: "styles" },
            { name: "paddingBottom", value: "20px", type: "styles" },
            { name: "paddingRight", value: "20px", type: "styles" },
          ],
          parent_id: created.id,
        });

        deleteComponentById(editorId);
        addNewComponent({
          id: editorId,
          type: "editor",
          sort_order: 1,
          parent_id: created.id,
          childElements: [],
        } as any);
        syncSelectionWithCreatedComponent(created);
      });

      return;

      // .then((x) => {
      //   deleteComponentById(editorId);
      //   addNewComponent({
      //     id: editorId,
      //     type: "editor",
      //     sort_order: 1,
      //     parent_id: x.payload[Object.keys(x.payload)[0]].id,
      //     childElements: [],
      //   } as any);
      //   //setEditableComponentId(x.payload[Object.keys(x.payload)[0]].id);
      //   setTimeout(() => {
      //     let y = document
      //       .getElementById(
      //         x.payload[Object.keys(x.payload)[0]].id.toString()
      //       )
      //       ?.querySelectorAll("[contenteditable]")[0] as HTMLElement;
      //     if (y) {
      //       let s = window.getSelection();
      //       let r = document.createRange();
      //       r.selectNodeContents(y);
      //       r.collapse(false);
      //       s?.removeAllRanges();
      //       s?.addRange(r);
      //     }
      //   }, 500);
      // });
    }

    if (type === "MediaSlider") {
      StructureAPI.addComponent(component.webpage_id, {
        type: type,
        sort_order: sortValue,
        attributes: [],
        parent_id: parentId,
      }).then((x: any) => {
        const created = x.payload[Object.keys(x.payload)[0]];
        deleteComponentById(editorId);
        addNewComponent({
          id: editorId,
          type: "editor",
          sort_order: 1,
          parent_id: created.id,
          childElements: [],
        } as any);
        syncSelectionWithCreatedComponent(created);
      });

      return;
    }

    if (type === "ContentComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: type,
        sort_order: sortValue,
        attributes: [
          {
            type: "attributes",
            name: "text",
            value: "<span style='fontSize: 24px'>Text content</span>",
          },
          {
            type: "attributes",
            name: "typography_id",
            value: typographies.find((x) => x.id === defaultTypography)?.id
              ? typographies.find((x) => x.id === defaultTypography)?.id
              : typographies.find((x: any) => x.tag == "p")?.id ?? null,
          },
        ],
        parent_id: parentId,
      });

      return;
    }

    if (type == "section") {
      StructureAPI.addComponent(component.webpage_id, {
        type: type,
        sort_order: nextSortOrder,
        attributes: [],
        parent_id: parentId,
      }).then((x: any) => {
        StructureAPI.addComponent(component.webpage_id, {
          type: "section",
          sort_order: 1,
          attributes: [
            {
              name: "classes",
              value: DEFAULT_NEW_COLUMN_CLASSES,
              type: "attributes",
            },
            { name: "paddingTop", value: "0px", type: "styles" },
            { name: "paddingLeft", value: "0px", type: "styles" },
            { name: "paddingBottom", value: "0px", type: "styles" },
            { name: "paddingRight", value: "0px", type: "styles" },
          ],
          parent_id: x.payload[Object.keys(x.payload)[0]].id,
        });
      });
      return;
    }

    if (type == "NavItemComponent") {
      StructureAPI.addComponent(component.webpage_id, {
        type: "nav-item",
        sort_order: nextSortOrder,
        attributes: [
          {
            type: "styles",
            name: "marginTop",
            value: "10px",
          },
          {
            type: "attributes",
            name: "text",
            value: "NavItemComponent",
          },
          {
            type: "attributes",
            name: "link",
            value: { url: "", type: "None", target: "" },
          },
        ],
        parent_id: parentId,
      });

      return;
      // type = "nav-item";
      // // {
      // //   type: 'nav-item',
      // //   sort_order: 1,
      // //   attributes: [

      // //   ],
      // // },
      // textAttributes = [
      //   {
      //     type: "attributes",
      //     name: "text",
      //     value: "NavItemComponent",
      //   },
      //   {
      //     type: "attributes",
      //     name: "link",
      //     value: { url: "/", type: "Web", target: "" },
      //   },
      // ];
    } else if (type == "form") {
      // At the moment only 1 form
      StructureAPI.addComponent(component.webpage_id, {
        type: "form",
        sort_order: nextSortOrder,
        attributes: [
          {
            type: "styles",
            name: "marginTop",
            value: "10px",
          },
          {
            type: "attributes",
            name: "action",
            value: "/webstoreApi/submitContactForm",
          },
        ],
        parent_id: parentId,
        childElements: [
          {
            type: "text",
            sort_order: 1,
            attributes: [
              {
                type: "attributes",
                name: "text",
                value:
                  '<span style="font-weight: normal;"><font style="font-size: 17px;">Nimi</font></span>',
              },
            ],
          },
          {
            type: "input",
            sort_order: 2,
            attributes: [
              { type: "attributes", name: "placeholder", value: "Teie nimi" },
              { type: "attributes", name: "name", value: "name" },
              { type: "attributes", name: "required", value: true },
            ],
          },
          {
            type: "text",
            sort_order: 3,
            attributes: [
              {
                type: "attributes",
                name: "text",
                value:
                  '<span style="font-weight: normal;"><font style="font-size: 17px;">Email address</font></span>',
              },
              { type: "styles", name: "marginTop", value: "15px" },
            ],
          },
          {
            type: "input",
            sort_order: 4,
            attributes: [
              {
                type: "attributes",
                name: "placeholder",
                value: "E-posti aadress",
              },
              { type: "attributes", name: "name", value: "email" },
              { type: "attributes", name: "required", value: true },
            ],
          },
          {
            type: "text",
            sort_order: 5,
            attributes: [
              {
                type: "attributes",
                name: "text",
                value:
                  '<span style="font-weight: normal;"><font style="font-size: 17px;">Sinu sõnum</font></span>',
              },
              { type: "styles", name: "marginTop", value: "15px" },
            ],
          },
          {
            type: "input",
            sort_order: 6,
            attributes: [
              { type: "attributes", name: "placeholder", value: "" },
              { type: "attributes", name: "text_area", value: true },
              { type: "attributes", name: "name", value: "content" },
              { type: "attributes", name: "required", value: true },
            ],
          },

          {
            type: "input",
            sort_order: 7,
            attributes: [
              { type: "attributes", name: "placeholder", value: "" },
              { type: "attributes", name: "name", value: "hash" },
              { type: "attributes", name: "content", value: "content" },
              { type: "attributes", name: "required", value: true },
              { type: "attributes", name: "hidden", value: true },
              { type: "attributes", name: "id", value: "hashconfirm" },
            ],
          },

          {
            type: "Button",
            sort_order: 8,
            attributes: [
              { type: "attributes", name: "text_area", value: true },
              { type: "attributes", name: "buttonType", value: "submit" },
              {
                type: "attributes",
                name: "text",
                value:
                  '<font style="font-size: 15px;" color="#ffffff">Saada</font>',
              },
              {
                type: "styles",
                name: "backgroundColor",
                value: "rgb(53, 158, 63)",
              },
              { type: "styles", name: "borderBottomWidth", value: "0px" },
              { type: "styles", name: "borderLeftWidth", value: "0px" },
              { type: "styles", name: "borderRightWidth", value: "0px" },
              { type: "styles", name: "borderTopWidth", value: "0px" },
              { type: "styles", name: "marginTop", value: "15px" },
              { type: "styles", name: "paddingTop", value: "10px" },
              { type: "styles", name: "paddingBottom", value: "10px" },
              { type: "styles", name: "paddingRight", value: "15px" },
              { type: "styles", name: "paddingLeft", value: "15px" },
              { type: "styles", name: "width", value: "100%" },

              { type: "styles", name: "display", value: "flex" },
              {
                type: "attributes",
                name: "typography_id",
                value: typographies.find((x) => x.id === defaultTypography)?.id
                  ? typographies.find((x) => x.id === defaultTypography)?.id
                  : typographies.find((x: any) => x.tag == "p")?.id ?? null,
              },
            ],
          },
        ],
      });
      return;
    } else if (type === "button") {
      textAttributes = [
        {
          type: "attributes",
          name: "type",
          value: "button",
        },
        {
          type: "attributes",
          name: "link",
          value: { url: "", type: "Page", target: "_self" },
        },
        {
          type: "attributes",
          name: "text",
          value: '<font color="#fff">Click me</font>',
        },
        {
          type: "attributes",
          name: "typography_id",
          value: typographies.find((x) => x.id === defaultTypography)?.id
            ? typographies.find((x) => x.id === defaultTypography)?.id
            : typographies.find((x: any) => x.tag == "p")?.id ?? null,
        },
        {
          type: "styles",
          name: "marginTop",
          value: "0px",
        },
        {
          type: "styles",
          name: "borderTopWidth",
          value: "0px",
        },
        {
          type: "styles",
          name: "borderBottomWidth",
          value: "0px",
        },
        {
          type: "styles",
          name: "borderLeftWidth",
          value: "0px",
        },
        {
          type: "styles",
          name: "borderRightWidth",
          value: "0px",
        },
        {
          type: "styles",
          name: "borderTopStyle",
          value: "solid",
        },
        {
          type: "styles",
          name: "borderBottomStyle",
          value: "solid",
        },
        {
          type: "styles",
          name: "borderLeftStyle",
          value: "solid",
        },
        {
          type: "styles",
          name: "borderRightStyle",
          value: "solid",
        },
        {
          type: "styles",
          name: "borderTopColor",
          value: "#616161",
        },
        {
          type: "styles",
          name: "borderBottomColor",
          value: "#616161",
        },
        {
          type: "styles",
          name: "borderLeftColor",
          value: "#616161",
        },
        {
          type: "styles",
          name: "borderRightColor",
          value: "#616161",
        },
        {
          type: "styles",
          name: "borderTopLeftRadius",
          value: "6px",
        },
        {
          type: "styles",
          name: "borderTopRightRadius",
          value: "6px",
        },
        {
          type: "styles",
          name: "borderBottomLeftRadius",
          value: "6px",
        },
        {
          type: "styles",
          name: "borderBottomRightRadius",
          value: "6px",
        },
        {
          type: "styles",
          name: "paddingTop",
          value: "0px",
        },
        {
          type: "styles",
          name: "paddingBottom",
          value: "0px",
        },
        {
          type: "styles",
          name: "paddingLeft",
          value: "0px",
        },
        {
          type: "styles",
          name: "display",
          value: "flex",
        },
        {
          type: "styles",
          name: "paddingRight",
          value: "0px",
        },
        {
          type: "styles",
          name: "backgroundColor",
          value: "#616161",
        },
      ];
    } else {
      textAttributes = [
        {
          type: "attributes",
          name: "text",
          value:
            type === "Button"
              ? "<span style='fontSize: 24px'>Button component</span>"
              : "<span style='fontSize: 24px'>Text content</span>",
        },
        {
          type: "attributes",
          name: "typography_id",
          value: typographies.find((x) => x.id === defaultTypography)?.id
            ? typographies.find((x) => x.id === defaultTypography)?.id
            : typographies.find((x: any) => x.tag == "p")?.id ?? null,
        },
        {
          type: "styles",
          name: "paddingTop",
          value: type === "Button" ? "10px" : "0px",
        },
        {
          type: "styles",
          name: "paddingBottom",
          value: type === "Button" ? "10px" : "0px",
        },
        {
          type: "styles",
          name: "paddingLeft",
          value: type === "Button" ? "20px" : "0px",
        },
        {
          type: "styles",
          name: "paddingRight",
          value: type === "Button" ? "20px" : "0px",
        },
        {
          type: "styles",
          name: "marginTop",
          value: "0px",
        },
        {
          type: "styles",
          name: "marginBottom",
          value: "0px",
        },
      ];
    }

    StructureAPI.addComponent(component.webpage_id, {
      type,
      sort_order: sortValue,
      attributes: textAttributes,
      parent_id: parentId,
    }).then((x) => {
      const created = x.payload[Object.keys(x.payload)[0]];
      deleteComponentById(editorId);
      addNewComponent({
        id: editorId,
        type: "editor",
        sort_order: 1,
        parent_id: created.id,
        childElements: [],
      } as any);
      syncSelectionWithCreatedComponent(created);
      setTimeout(() => {
        const domId = getComponentDomId(created);
        let y = document
          .getElementById(domId)
          ?.querySelectorAll("[contenteditable]")[0] as HTMLElement;
        if (y) {
          let s = window.getSelection();
          let r = document.createRange();
          r.selectNodeContents(y);
          r.collapse(false);
          s?.removeAllRanges();
          s?.addRange(r);
        }
      }, 500);
    });
  }

  return (
    <ul className="m-0 p-0">
      <div className="select-element-type__container" style={style}>
        <div
          className={
            "select-element-type__list" + (expanded ? "" : " flex-nowrap")
          }
        >
          {component.type === "navigation-container" ? (
            <>
              <div
                key={"nav-item"}
                className="select-element-type__list__item"
                onClick={() => onTypeClick("nav-item")}
              >
                Nav item
              </div>
            </>
          ) : (
            <></>
          )}

          {component.type !== "navigation-container" &&
            (expanded ? elementTypes : quickTypes).map((x) => (
              <div
                key={x.value}
                className="select-element-type__list__item"
                onClick={() => onTypeClick(x.value)}
              >
                {x.label}
              </div>
            ))}
        </div>

        {component.type !== "nav" &&
          component.type !== "navigation-container" && (
            <>
              <MoreHorizOutlined
                style={{
                  fontSize: "22.5px",
                  alignSelf: "center",
                  marginLeft: "5px",
                }}
                onClick={() => toggleExpanded()}
              />
            </>
          )}
      </div>
    </ul>
  );
}
